import { useEffect, useMemo, useState } from "react";
import { FaCheck, FaSpinner } from "react-icons/fa";
import api from "../../services/axios";
import { toast } from "react-toastify";

const LinhaModalReunioes = ({
  participante,
  id,
  data,
  dia,
  carregarParticipantes,
  mostrarIncluir,
  jaMarcado,
  setLoading,
  slotsDoDia = [],
  tipoAgenda = "reuniao_negocio",
  idPatrocinador,
}) => {
  const [aberto, setAberto] = useState(false);
  const [hora, setHora] = useState("");
  const [salvando, setSalvando] = useState(false);
  const isMatchMeet = tipoAgenda === "m_m";

  const horariosSelecionaveis = useMemo(() => {
    if (Array.isArray(participante.horariosSelecionaveis)) {
      return participante.horariosSelecionaveis;
    }
    return String(participante.selectdisponibilidade || "")
      .split(" ")
      .filter(Boolean);
  }, [participante]);

  const horariosDisponiveis = useMemo(() => {
    if (Array.isArray(participante.horariosDisponiveis)) {
      return participante.horariosDisponiveis;
    }
    return String(participante.disponibilidade || "")
      .split(" ")
      .filter(Boolean);
  }, [participante]);

  useEffect(() => {
    setAberto(false);
    setHora("");
  }, [data, dia]);

  const slotSelecionado = useMemo(() => {
    if (!hora) return null;
    return (
      slotsDoDia.find((slot) => {
        const inicio = String(slot.horario_inicio || "").substring(0, 5);
        return inicio === hora;
      }) || null
    );
  }, [hora, slotsDoDia]);

  const salvarReuniao = async () => {
    if (!hora) {
      toast.warning("Escolha um horário disponível.");
      return;
    }

    setSalvando(true);
    setLoading?.(true);

    try {
      const payload = {
        id_interessado: Number(id),
        id_convidado: participante.id,
        horario: hora,
        dia,
        data,
        tipo: isMatchMeet ? "m_m" : "reuniao_negocio",
      };

      if (slotSelecionado?.id) {
        payload.id_slot = slotSelecionado.id;
      }
      if (isMatchMeet && idPatrocinador) {
        payload.id_patrocinador = Number(idPatrocinador);
      }

      const resp = await api.post("/reunioes", payload);
      if (resp.status === 200) {
        if (resp.data?.status === "erro") {
          toast.error(
            resp.data?.mensagem ||
              (isMatchMeet
                ? "Não foi possível criar o Match & Meet."
                : "Não foi possível criar a reunião.")
          );
        } else {
          toast.success(
            resp.data?.mensagem ||
              (isMatchMeet
                ? "Match & Meet criado com sucesso!"
                : "Reunião criada com sucesso!")
          );
          setAberto(false);
          setHora("");
          await carregarParticipantes?.();
        }
      }
    } catch (err) {
      console.error("Erro ao criar reunião:", err);
      toast.error(
        err?.response?.data?.mensagem ||
          (isMatchMeet
            ? "Erro ao criar o Match & Meet. Tente novamente."
            : "Erro ao criar a reunião. Tente novamente.")
      );
    } finally {
      setSalvando(false);
      setLoading?.(false);
    }
  };

  return (
    <div className={`mr-row${aberto ? " is-open" : ""}`}>
      <div
        className="mr-row-main"
        onClick={() => setAberto((prev) => !prev)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setAberto((prev) => !prev);
          }
        }}
      >
        <div className="mr-cell-name" title={participante.nome}>
          {participante.nome || "—"}
        </div>
        <div className="mr-cell-muted" title={participante.empresa}>
          {participante.empresa || "—"}
        </div>
        <div className="mr-cell-muted" title={participante.cargo}>
          {participante.cargo || "—"}
        </div>
        <div className="mr-slots">
          {horariosDisponiveis.length > 0 ? (
            horariosDisponiveis.map((h) => (
              <span key={`${participante.id}-${h}`} className="mr-slot-chip">
                {h}
              </span>
            ))
          ) : (
            <span className="mr-slot-chip mr-slot-chip--muted">Sem horários</span>
          )}
        </div>
      </div>

      {aberto ? (
        <div className="mr-row-panel">
          <div className="mr-row-panel-inner">
            {jaMarcado ? (
              <div className="mr-warn-inline">
                Já existe uma reunião com este convidado.
              </div>
            ) : null}

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.45rem",
                  fontSize: "0.6875rem",
                  fontWeight: 700,
                  letterSpacing: "0.05em",
                  textTransform: "uppercase",
                  color: "#64748b",
                }}
              >
                Horário disponível
              </label>
              {horariosSelecionaveis.length === 0 ? (
                <p className="mr-warn-inline" style={{ margin: 0 }}>
                  Nenhum horário selecionável neste dia (cota ou agenda do
                  convidado).
                </p>
              ) : (
                <div className="mr-slot-picker" role="listbox" aria-label="Horários">
                  {horariosSelecionaveis.map((h) => (
                    <button
                      key={`opt-${participante.id}-${h}`}
                      type="button"
                      className={`mr-slot-option${
                        hora === h ? " is-selected" : ""
                      }`}
                      onClick={() => setHora(h)}
                      disabled={salvando || jaMarcado}
                    >
                      {h}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="mr-panel-actions">
              <button
                type="button"
                className="mr-btn mr-btn--ghost"
                onClick={() => {
                  setAberto(false);
                  setHora("");
                }}
                disabled={salvando}
              >
                Cancelar
              </button>
              {mostrarIncluir && participante.mostrarbotao && !jaMarcado ? (
                <button
                  type="button"
                  className="mr-btn mr-btn--primary"
                  onClick={salvarReuniao}
                  disabled={salvando || !hora}
                >
                  {salvando ? (
                    <FaSpinner className="fa-spin" size={13} aria-hidden />
                  ) : (
                    <FaCheck size={13} aria-hidden />
                  )}
                  {salvando
                    ? "Confirmando…"
                    : isMatchMeet
                      ? "Confirmar M&M"
                      : "Confirmar reunião"}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LinhaModalReunioes;
